import api from "./api";

export interface ProfilePhoto {
  id: number;
  name: string;
  photoUrl: string;
}

export const getProfilePhotos = async (): Promise<ProfilePhoto[]> => {
  try {
    const response = await api.get<ProfilePhoto[]>("/auth/admin/profile-photos");
    return response.data;
  } catch (error) {
    console.error("Error fetching profile photos:", error);
    throw error;
  }
};

export const deleteProfilePhoto = async (userId: number): Promise<void> => {
  try {
    await api.delete(`/auth/admin/profile-photos/${userId}`);
  } catch (error) {
    console.error(`Error deleting profile photo for user=${userId}:`, error);
    throw error;
  }
};
